<template>
    <div>
        <h2 class="h1 text-center font-normal text-black pb-4">Nyheter</h2>
        <div v-if="loaded">
            <div
                v-for="item in news"
                :key="item.id"
                class="border-b border-solid border-mimer-turquoise relative w-full lg:w-2/3 mx-auto flex flex-col bg-white">
                <div>
                    <div v-on:click="showInfo(item.id)" class="flex cursor-pointer items-center text-sm md:text-base">
                        <figure
                            class="hidden md:block w-10 min-h-full py-4 text-white text-center bg-mimer-turquoise border-none">
                            <i class="material-icons py-2 text-3xl">info</i>
                        </figure>
                        <div class="block w-5/12 md:w-6/12 p-1 px-0 pl-2 py-4 text-start hover:underline">
                            <p class="p-0 md:truncate">{{ item.title.rendered }}</p>
                        </div>
                        <div class="block w-3/12 pl-2 pr-1 py-4 text-start truncate">
                            <span class="truncate max-w-md">{{ regions(item.omrade) }}</span>
                        </div>
                        <div class="block w-2/12 px-2 py-4 text-start text-sm">
                            <span>{{ date(item.date) }}</span>
                        </div>
                        <div class="block w-1/12 px-2 py-4 text-center">
                            <i class="material-icons text-4xl">expand_more</i>
                        </div>
                    </div>
                </div>
                <div v-if="newsToShow == item.id">
                    <div class="p-8" v-html="item.content.rendered"></div>
                </div>
            </div>
            <div class="flex justify-around">
                <a
                    class="inline-block p-2 px-4 mt-4 rounded-lg no-underline hover:underline"
                    :href="baseurl + '/nyheter'"
                    target="_blank"
                    >Se alla nyheter på mimer.nu</a
                >
            </div>
        </div>
        <div v-else>
            <div v-for="i in 3" :key="i" class="h-16 w-full lg:w-2/3 mx-auto bg-gray-300 mb-2 animate-pulse"></div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import dayjs from 'dayjs';
import 'dayjs/locale/sv';
import { contractsStore } from '../../stores/contracts';

export default {
    name: 'NewsList',
    data() {
        return {
            baseurl: location.origin,
            loaded: false,
            news: [],
            newsToShow: null,
        };
    },
    methods: {
        regions(value) {
            if (value === '' || value === false || value === undefined || value === null || value.length == 0) return;
            if (typeof value == 'string') return value;
            if (value.length == 1) return value[0];
            return value.slice(0, value.length - 1).join(', ') + ' och ' + value[value.length - 1];
        },
        date(value) {
            return dayjs(value).format('DD MMM');
        },
        showInfo(id) {
            if (this.newsToShow === id) {
                this.newsToShow = null;
            } else {
                this.newsToShow = id;
            }
        },
    },
    async created() {
        const cStore = contractsStore();
        let locContracts = cStore.contracts;
        if (!locContracts) {
            await cStore.fetchContracts();
        }

        let districts = cStore.getDisctricts;
        let response = await axios.get(location.origin + '/wp-json/wp/v2/news', {
            params: { omrade: [...districts, 'Alla områden'], per_page: 3 },
        });
        this.news = response?.data || [];
        this.loaded = true;
    },
};
</script>
